const SearchIcon = (props) => (
  <svg
    width={14}
    height={14}
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.53033 8.46967C9.23744 8.17678 8.76256 8.17678 8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033L9.53033 8.46967ZM12.4697 13.5303C12.7626 13.8232 13.2374 13.8232 13.5303 13.5303C13.8232 13.2374 13.8232 12.7626 13.5303 12.4697L12.4697 13.5303ZM5.66667 9.58333C3.50355 9.58333 1.75 7.82978 1.75 5.66667H0.25C0.25 8.65821 2.67512 11.0833 5.66667 11.0833V9.58333ZM1.75 5.66667C1.75 3.50355 3.50355 1.75 5.66667 1.75V0.25C2.67512 0.25 0.25 2.67512 0.25 5.66667H1.75ZM5.66667 1.75C7.82978 1.75 9.58333 3.50355 9.58333 5.66667H11.0833C11.0833 2.67512 8.65821 0.25 5.66667 0.25V1.75ZM9.58333 5.66667C9.58333 7.82978 7.82978 9.58333 5.66667 9.58333V11.0833C8.65821 11.0833 11.0833 8.65821 11.0833 5.66667H9.58333ZM8.46967 9.53033L12.4697 13.5303L13.5303 12.4697L9.53033 8.46967L8.46967 9.53033Z'
      fill='currentColor'
    />
  </svg>
);
export default SearchIcon;
